import React, { useEffect, useState, useContext } from "react";
import "./BannerSection.css";
import { useParams } from "react-router-dom";
import { BlogById } from "../../../../utils/apis/blog/Blog";
import { Context } from "../../../../utils/context";
import { IDS } from "../../../../utils/common";
import ExperiencePower from "../../../gallary_showcase/experience_power/ExperiencePower";

const Blog_Banner = () => {
  const { id } = useParams();
  const { IMG_URL } = useContext(Context);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [blog, setBlog] = useState({});

  const getBlog = async () => {
    const res = await BlogById(id);
    if (res?.success) {
      setBlog(res?.data || {});
    }
  };

  useEffect(() => {
    if (id) getBlog();
  }, [id]);

  /*----------- for para limit --------- */
  const [maxLength, setMaxLength] = useState(1154);
  //   useEffect(() => {
  //     const handleResize = () => {
  //       if (window.innerWidth <= 576) {
  //         setMaxLength(200);
  //       } else if (window.innerWidth <= 768) {
  //         setMaxLength(350);
  //       } else if (window.innerWidth <= 992) {
  //         setMaxLength(500);
  //       } else if (window.innerWidth <= 1200) {
  //         setMaxLength(1000);
  //       } else {
  //         setMaxLength(1154);
  //       }
  //     };

  //     handleResize();
  //     window.addEventListener("resize", handleResize);

  //     return () => window.removeEventListener("resize", handleResize);
  //   }, []);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width >= 1400) {
        setMaxLength(1150);
      } else if (width >= 1200) {
        setMaxLength(1050);
      } else if (width >= 992) {
        setMaxLength(800);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fullText = `Live concerts are more than just music—they are a full sensory experience where sound, lights, & crowd energy come together to create unforgettable moments. From the first beat drop to the final encore, every second is packed with excitement, emotion, and pure adrenaline.
  One of the biggest highlights of modern concerts is the use of high-impact effects like CO₂ blasts, flame jets, confetti cannons, and laser lights. These elements transform a simple performance into a visual spectacle, amplifying the mood & keeping the audience fully engaged. When the bass hits & CO₂ jets burst into the air, the crowd doesn’t just watch they feel it.

  One of the biggest highlights of modern concerts is the use of
  high-impact effects like CO₂ blasts, flame jets, confetti cannons,
  and laser lights. These elements transform a simple performance
  into a visual spectacle.
  
  Beyond entertainment, these effects play a powerful role in branding and audience connection. Artists and event organizers use them to create signature moments that people capture, share, & remember. Whether it’s a dramatic flame burst during a drop or a shower of confetti at the finale, these visuals turn concerts into shareable experiences.
  
  
  In today’s event landscape, a “Live Concert Blast” is all about creating impact—combining music with immersive effects to leave a lasting impression. It’s not just about hearing the music anymore; it’s about living the experience.
  In today’s event landscape, a “Live Concert Blast” is all about creating impact—combining music with immersive effects to leave a lasting impression. It’s not just about hearing the music anymore; it’s about living the experience.
  In today’s event landscape, a “Live Concert Blast” is all about creating impact—combining music with immersive effects to leave a lasting impression. It’s not just about hearing the music anymore; it’s about living the experience.
  In today’s event landscape, a “Live Concert Blast” is all about creating impact—combining music with immersive effects to leave a lasting impression. It’s not just about hearing the music anymore; it’s about living the experience.
  In today’s event landscape, a “Live Concert Blast” is all about creating impact—combining music with immersive effects to leave a lasting impression. It’s not just about hearing the music anymore; it’s about living the experience.
  In today’s event landscape, a “Live Concert Blast” is all about creating impact—combining music with immersive effects to leave a lasting impression. It’s not just about hearing the music anymore; it’s about living the experience.
  
  
  `;
  // const introText = fullText.slice(0, maxLength);
  // const remainingText = fullText.slice(maxLength);

  const description = blog?.description || "";

  const introText = description.slice(0, maxLength);
  const remainingText = description.slice(maxLength);
  return (
    <section className="blog-banner-section">
      <div className="container">
        {/* <div className="blog_top_section">
          <div className="blog_left">
            <img
              src={IDS?.IMG_URL + blog?.image}
              alt="blog-banner"
              className="blog_img"
            />
          </div>

          <div className="blog_right">
            <h2 className="blog_title">{blog?.name}</h2>

            <span className="blog_date">
              {blog?.createdAt &&
                new Date(blog.createdAt).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })}
            </span>

            <div className="blog_intro">
              <p>{htmlToReactParser.parse(introText)}</p>
            </div>
          </div>
        </div> */}
        <div className="blog_content ">
          <img
            src={IDS?.IMG_URL + blog?.image}
            alt="blog-banner"
            className="blog_img_float"
          />

          <h2 className="blog_title">{blog?.name}</h2>

          <span className="blog_date">
            {blog?.createdAt &&
              new Date(blog.createdAt).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
          </span>

          <p className="blog_intro">
            {htmlToReactParser.parse(introText + remainingText)}
          </p>
        </div>

        <ExperiencePower />
        <div className="blog_desc_full">
          <p>
            {" "}
            {/* Beyond entertainment, these effects play a powerful role in branding
            and audience connection. Artists and event organizers use them to
            create signature moments that people capture, share, & remember.
            Whether it’s a dramatic flame burst during a drop or a shower of
            confetti at the finale, these visuals turn concerts into shareable
            experiences. In today’s event landscape, a “Live Concert Blast” is
            all about creating impact—combining music with immersive effects to
            leave a lasting impression. It’s not just about hearing the music
            anymore; it’s about living the experience. */}
          </p>

          <p className="blog_intro">
            {/* In today’s event landscape, a “Live Concert Blast” is all about
            creating impact—combining music with immersive effects to leave a
            lasting impression. It’s not just about hearing the music anymore;
            it’s about living the experience. */}
            {htmlToReactParser.parse(blog?.conclusion)}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Blog_Banner;
